var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bonus)?_c('span',{staticClass:"bonus",staticStyle:{"color":"#ff3300"},attrs:{"title":"bonus"}},[_vm._v("Bonus: "+_vm._s(_vm.priceStr))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }